// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1__G0","cls2":"PaperAbstract-cls2_l31 PaperAbstract-cls1__G0"};